import { boxCollect } from '@/components/ElectronLayout/ElectronHead/popup/server';

export async function openServerCollect(key?: any, type?: number, data?: any) {
  if (key) {
    let keyNum = 0;
    let typeNum = 0;
    let keyName = 'cckaifu_';

    let collectKey = 701;
    const navId = Number(localStorage.getItem('NAV_TABBTN_ID'));
    if (navId !== 1) {
      keyName = 'cskaifu_';
      collectKey = 1459;
    }
    if (type && type === 2) {
      if (navId === 1) typeNum = 31;
    } else if (type && type === 3) {
      if (navId === 1) {
        collectKey = 474;
        keyName = 'shouye_cckaifuliebiao';
      } else {
        collectKey = 1;
        keyName = 'shouye_cskaifuliebiao_';
      }
    }

    if (key <= 20) {
      keyNum = key + collectKey + typeNum;
      if (type === 3) keyName = keyName + key + '_';
    } else if (key <= 30) {
      keyNum = collectKey + 21 + typeNum;
      if (type === 3) keyName = keyName + '21~30_';
    } else if (key <= 40) {
      keyNum = collectKey + 22 + typeNum;
      if (type === 3) keyName = keyName + '31~40_';
    } else if (key <= 50) {
      keyNum = collectKey + 23 + typeNum;
      if (type === 3) keyName = keyName + '41~50_';
    } else if (key <= 60) {
      keyNum = collectKey + 24 + typeNum;
      if (type === 3) keyName = keyName + '51~60_';
    } else if (key <= 70) {
      keyNum = collectKey + 25 + typeNum;
      if (type === 3) keyName = keyName + '61~70_';
    } else if (key <= 80) {
      keyNum = collectKey + 26 + typeNum;
      if (type === 3) keyName = keyName + '71~80_';
    } else if (key <= 90) {
      keyNum = collectKey + 27 + typeNum;
      if (type === 3) keyName = keyName + '81~90_';
    } else if (key <= 100) {
      keyNum = collectKey + 28 + typeNum;
      if (type === 3) keyName = keyName + '91~100_';
    } else if (key > 100) {
      keyNum = collectKey + 29 + typeNum;
      if (type === 3) keyName = keyName + '100n_';
    }
    if (navId !== 1 && type && type === 3) {
      if (key <= 20) {
        keyNum = key - 1 + 1382;
      } else {
        collectItemList.some((item: any) => {
          if (key <= item.num) keyNum = item.collectKey;
          return key <= item.num;
        });
      }
      keyName = 'shouye_cskaifuliebiao_';
    }
    await boxCollect(`${keyName}${keyNum}`, data);
  }
}

export async function onOpenServerCollect(key?: any, data?: any) {
  console.log(key, 33333);
  if (key) {
    if (Number(localStorage.getItem('NAV_TABBTN_ID')) === 1) {
      await boxCollect(openServerCollectObj[key], data);
    } else {
      await boxCollect(openServerCollectObjCS[key], data);
    }
  }
}

export const openServerCollectObj = {
  // 传奇开服列表进入游戏详情
  731: 'cckaifu_731',
  // 传奇开服列表进游戏详情并启游
  732: 'cckaifu_732',
  // 传世开服列表进入游戏详情
  762: 'cckaifu_762',
  // 传世开服列表进游戏详情并启游
  763: 'cckaifu_763',
  // 首页传奇开服列表进入游戏详情
  504: 'shouye_cckaifuliebiao_youxixiangqing_504',
  // 首页传奇开服列表进游戏详情并启游
  505: 'shouye_cckaifuliebiao_youxixiangqing_505',
  // 首页传奇开服列表更多按钮
  506: 'shouye_cckaifuliebiao_gengduo_506'
};
// 传世开服列表进入游戏详情				cskaifu_1489
// 传世开服列表进游戏详情并启游				cskaifu_1490
export const openServerCollectObjCS = {
  // 传奇开服列表进入游戏详情
  731: 'cckaifu_731',
  // 传奇开服列表进游戏详情并启游
  732: 'cckaifu_732',
  // 传世开服列表进入游戏详情
  762: 'cskaifu_1489',
  // 传世开服列表进游戏详情并启游
  763: 'cskaifu_1490',
  // 首页传世开服列表进入游戏详情
  504: 'shouye_cskaifuliebiao_1411',
  // 首页传世开服列表进游戏详情并启游
  505: 'shouye_cskaifuliebiao_1412',
  // 首页传世开服列表更多按钮
  506: 'shouye_cskaifuliebiao_1413'
};

export const collectItemList = [
  {
    collectKey: 1402,
    num: 30
  },
  {
    collectKey: 1403,
    num: 40
  },
  {
    collectKey: 1404,
    num: 50
  },
  {
    collectKey: 1405,
    num: 60
  },
  {
    collectKey: 1406,
    num: 70
  },
  {
    collectKey: 1407,
    num: 80
  },
  {
    collectKey: 1408,
    num: 90
  },
  {
    collectKey: 1409,
    num: 100
  },
  {
    collectKey: 1410,
    num: 1000
  }
];

// 传奇开服列表点击位置1		cckaifu_702
// 传奇开服列表点击位置2		cckaifu_703
// 传奇开服列表点击位置3		cckaifu_704
// 传奇开服列表点击位置4		cckaifu_705
// 传奇开服列表点击位置5		cckaifu_706
// 传奇开服列表点击位置6		cckaifu_707
// 传奇开服列表点击位置7		cckaifu_708
// 传奇开服列表点击位置8		cckaifu_709
// 传奇开服列表点击位置9		cckaifu_710
// 传奇开服列表点击位置10		cckaifu_711
// 传奇开服列表点击位置11		cckaifu_712
// 传奇开服列表点击位置12		cckaifu_713
// 传奇开服列表点击位置13		cckaifu_714
// 传奇开服列表点击位置14		cckaifu_715
// 传奇开服列表点击位置15		cckaifu_716
// 传奇开服列表点击位置16		cckaifu_717
// 传奇开服列表点击位置17		cckaifu_718
// 传奇开服列表点击位置18		cckaifu_719
// 传奇开服列表点击位置19		cckaifu_720
// 传奇开服列表点击位置20		cckaifu_721
// 传奇开服列表点击位置21~30		cckaifu_722
// 传奇开服列表点击位置31~40		cckaifu_723
// 传奇开服列表点击位置41~50		cckaifu_724
// 传奇开服列表点击位置51~60		cckaifu_725
// 传奇开服列表点击位置61~70		cckaifu_726
// 传奇开服列表点击位置71~80		cckaifu_727
// 传奇开服列表点击位置81~90		cckaifu_728
// 传奇开服列表点击位置91~100		cckaifu_729
// 传奇开服列表点击位置100以上		cckaifu_730

// 传世开服列表点击位置1		cckaifu_733
// 传世开服列表点击位置2		cckaifu_734
// 传世开服列表点击位置3		cckaifu_735
// 传世开服列表点击位置4		cckaifu_736
// 传世开服列表点击位置5		cckaifu_737
// 传世开服列表点击位置6		cckaifu_738
// 传世开服列表点击位置7		cckaifu_739
// 传世开服列表点击位置8		cckaifu_740
// 传世开服列表点击位置9		cckaifu_741
// 传世开服列表点击位置10		cckaifu_742
// 传世开服列表点击位置11		cckaifu_743
// 传世开服列表点击位置12		cckaifu_744
// 传世开服列表点击位置13		cckaifu_745
// 传世开服列表点击位置14		cckaifu_746
// 传世开服列表点击位置15		cckaifu_747
// 传世开服列表点击位置16		cckaifu_748
// 传世开服列表点击位置17		cckaifu_749
// 传世开服列表点击位置18		cckaifu_750
// 传世开服列表点击位置19		cckaifu_751
// 传世开服列表点击位置20		cckaifu_752
// 传世开服列表点击位置21~30		cckaifu_753
// 传世开服列表点击位置31~40		cckaifu_754
// 传世开服列表点击位置41~50		cckaifu_755
// 传世开服列表点击位置51~60		cckaifu_756
// 传世开服列表点击位置61~70		cckaifu_757
// 传世开服列表点击位置71~80		cckaifu_758
// 传世开服列表点击位置81~90		cckaifu_759
// 传世开服列表点击位置91~100		cckaifu_760
// 传世开服列表点击位置100以上		cckaifu_761

// 首页传奇开服列表点击位置1		shouye_cckaifuliebiao1_475
// 首页传奇开服列表点击位置2		shouye_cckaifuliebiao2_476
// 首页传奇开服列表点击位置3		shouye_cckaifuliebiao3_477
// 首页传奇开服列表点击位置4		shouye_cckaifuliebiao4_478
// 首页传奇开服列表点击位置5		shouye_cckaifuliebiao5_479
// 首页传奇开服列表点击位置6		shouye_cckaifuliebiao6_480
// 首页传奇开服列表点击位置7		shouye_cckaifuliebiao7_481
// 首页传奇开服列表点击位置8		shouye_cckaifuliebiao8_482
// 首页传奇开服列表点击位置9		shouye_cckaifuliebiao9_483
// 首页传奇开服列表点击位置10		shouye_cckaifuliebiao10_484
// 首页传奇开服列表点击位置11		shouye_cckaifuliebiao11_485
// 首页传奇开服列表点击位置12		shouye_cckaifuliebiao12_486
// 首页传奇开服列表点击位置13		shouye_cckaifuliebiao13_487
// 首页传奇开服列表点击位置14		shouye_cckaifuliebiao14_488
// 首页传奇开服列表点击位置15		shouye_cckaifuliebiao15_489
// 首页传奇开服列表点击位置16		shouye_cckaifuliebiao16_490
// 首页传奇开服列表点击位置17		shouye_cckaifuliebiao17_491
// 首页传奇开服列表点击位置18		shouye_cckaifuliebiao18_492
// 首页传奇开服列表点击位置19		shouye_cckaifuliebiao19_493
// 首页传奇开服列表点击位置20		shouye_cckaifuliebiao20_494
// 首页传奇开服列表点击位置21~30		shouye_cckaifuliebiao21~30_495
// 首页传奇开服列表点击位置31~40		shouye_cckaifuliebiao31~40_496
// 首页传奇开服列表点击位置41~50		shouye_cckaifuliebiao41~50_497
// 首页传奇开服列表点击位置51~60		shouye_cckaifuliebiao51~60_498
// 首页传奇开服列表点击位置61~70		shouye_cckaifuliebiao61~70_499
// 首页传奇开服列表点击位置71~80		shouye_cckaifuliebiao71~80_500
// 首页传奇开服列表点击位置81~90		shouye_cckaifuliebiao81~90_501
// 首页传奇开服列表点击位置91~100		shouye_cckaifuliebiao91~100_502
// 首页传奇开服列表点击位置100以上		shouye_cckaifuliebiao100n_503

// 首页传世开服列表点击位置1		shouye_cskaifuliebiao_1382
// 首页传世开服列表点击位置2		shouye_cskaifuliebiao_1383
// 首页传世开服列表点击位置3		shouye_cskaifuliebiao_1384
// 首页传世开服列表点击位置4		shouye_cskaifuliebiao_1385
// 首页传世开服列表点击位置5		shouye_cskaifuliebiao_1386
// 首页传世开服列表点击位置6		shouye_cskaifuliebiao_1387
// 首页传世开服列表点击位置7		shouye_cskaifuliebiao_1388
// 首页传世开服列表点击位置8		shouye_cskaifuliebiao_1389
// 首页传世开服列表点击位置9		shouye_cskaifuliebiao_1390
// 首页传世开服列表点击位置10		shouye_cskaifuliebiao_1391
// 首页传世开服列表点击位置11		shouye_cskaifuliebiao_1392
// 首页传世开服列表点击位置12		shouye_cskaifuliebiao_1393
// 首页传世开服列表点击位置13		shouye_cskaifuliebiao_1394
// 首页传世开服列表点击位置14		shouye_cskaifuliebiao_1395
// 首页传世开服列表点击位置15		shouye_cskaifuliebiao_1396
// 首页传世开服列表点击位置16		shouye_cskaifuliebiao_1397
// 首页传世开服列表点击位置17		shouye_cskaifuliebiao_1398
// 首页传世开服列表点击位置18		shouye_cskaifuliebiao_1399
// 首页传世开服列表点击位置19		shouye_cskaifuliebiao_1400
// 首页传世开服列表点击位置20		shouye_cskaifuliebiao_1401
// 首页传世开服列表点击位置21~30		shouye_cskaifuliebiao_1402
// 首页传世开服列表点击位置31~40		shouye_cskaifuliebiao_1403
// 首页传世开服列表点击位置41~50		shouye_cskaifuliebiao_1404
// 首页传世开服列表点击位置51~60		shouye_cskaifuliebiao_1405
// 首页传世开服列表点击位置61~70		shouye_cskaifuliebiao_1406
// 首页传世开服列表点击位置71~80		shouye_cskaifuliebiao_1407
// 首页传世开服列表点击位置81~90		shouye_cskaifuliebiao_1408
// 首页传世开服列表点击位置91~100		shouye_cskaifuliebiao_1409
// 首页传世开服列表点击位置100以上		shouye_cskaifuliebiao_1410

// 传世开服列表点击位置1		cskaifu_1460
// 传世开服列表点击位置2		cskaifu_1461
// 传世开服列表点击位置3		cskaifu_1462
// 传世开服列表点击位置4		cskaifu_1463
// 传世开服列表点击位置5		cskaifu_1464
// 传世开服列表点击位置6		cskaifu_1465
// 传世开服列表点击位置7		cskaifu_1466
// 传世开服列表点击位置8		cskaifu_1467
// 传世开服列表点击位置9		cskaifu_1468
// 传世开服列表点击位置10		cskaifu_1469
// 传世开服列表点击位置11		cskaifu_1470
// 传世开服列表点击位置12		cskaifu_1471
// 传世开服列表点击位置13		cskaifu_1472
// 传世开服列表点击位置14		cskaifu_1473
// 传世开服列表点击位置15		cskaifu_1474
// 传世开服列表点击位置16		cskaifu_1475
// 传世开服列表点击位置17		cskaifu_1476
// 传世开服列表点击位置18		cskaifu_1477
// 传世开服列表点击位置19		cskaifu_1478
// 传世开服列表点击位置20		cskaifu_1479
// 传世开服列表点击位置21~30		cskaifu_1480
// 传世开服列表点击位置31~40		cskaifu_1481
// 传世开服列表点击位置41~50		cskaifu_1482
// 传世开服列表点击位置51~60		cskaifu_1483
// 传世开服列表点击位置61~70		cskaifu_1484
// 传世开服列表点击位置71~80		cskaifu_1485
// 传世开服列表点击位置81~90		cskaifu_1486
// 传世开服列表点击位置91~100		cskaifu_1487
// 传世开服列表点击位置100以上		cskaifu_1488
